export default __webpack_public_path__ + "static/media/Biodiesel50_50.a8cbbbfa.svg";